import observeEntry from '@mlaroy/observe-entry/src';

export const fadeIn = (() => {

	// assign to variable to get the object
	const observer = observeEntry( '.fade-in-target' );
})();
